<template>
  <q-carousel
    animated
    v-model="slide"
    arrows
    navigation
    infinite
    :autoplay="5000"
    transition-prev="slide-right"
    transition-next="slide-left"
    height="420px"
    class="bg-dark text-white rounded-borders shadow-4 overflow-hidden q-mb-lg"
  >
    <q-carousel-slide
      v-for="(item, i) in itemsimg"
      :key="i"
      :name="i"
      :img-src="item.src"
      class="column no-wrap flex-center text-center text-white"
    >
      <div style="background: rgba(0, 0, 0, 0.6); border-radius: 12px; max-width: 700px; width: 90%;" class="q-pa-xl shadow-6">
        <div class="text-h3 text-weight-bolder text-white q-mb-sm">
          SOLUCIONES DE SOFTWARE
        </div>
        <div class="text-h6 text-grey-2 text-weight-regular q-mb-lg">
          Gestión empresarial y facturación para todo tipo de negocio
        </div>
        <q-btn
          color="primary"
          label="SABER MÁS"
          icon-right="arrow_forward"
          unelevated
          size="md"
          class="q-px-xl q-py-xs text-weight-bold shadow-3"
          to="/documentacion"
        />
      </div>
    </q-carousel-slide>
  </q-carousel>
</template>

<script>
export default {
  name: "MainCarrusel",
  data() {
    return {
      slide: 0,
      itemsimg: [
        { src: require("@/assets/logo/slider_1.jpg") },
        { src: require("@/assets/logo/slider_2.jpg") },
        { src: require("@/assets/logo/slider_3.jpg") },
      ],
    };
  },
};
</script>
